exports.lower = 'abcdefghijklmnopqrstuvwxyz';
exports.upper = exports.lower.toUpperCase();
exports.consonants = 'bcdfghjklmnpqrstvwxyz';
exports.vowels = 'aeiou';
exports.digits = '1234567890';
exports.symbols = '!@#$%^&*()';
exports.fullSymbols = '!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~';
exports.copyableSymbols = '_';
